// Replaces the legacy `glo:pl` scratch queue (docs/reverse-engineering-spec.md
// §4.7) -- a genuinely global "Add to Print List" batch, reachable from
// wherever a Deed record can be opened (the standalone Deeds screen, or a
// Deed nested inside an Addition/Sub-Addition detail dialog), not owned by
// any one screen. A Vuex module (mirroring the `auth` module) is the
// natural fit for that, same as the legacy queue lived in a global rather
// than any one procedure's local state.
export const printList = {
  namespaced: true,
  state: () => ({
    items: [], // { book, pg }
  }),
  mutations: {
    add(state, { book, pg }) {
      const exists = state.items.some((i) => i.book === book && i.pg === pg);
      if (!exists) state.items.push({ book, pg });
    },
    removeAt(state, idx) {
      state.items.splice(idx, 1);
    },
    setAll(state, items) {
      state.items = items;
    },
    clear(state) {
      state.items = [];
    },
  },
  getters: {
    items: (state) => state.items,
    count: (state) => state.items.length,
  },
};

export default printList;
